
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/become-a-partner",
      function () {
        return require("private-next-pages/sa/become-a-partner.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/become-a-partner"])
      });
    }
  